var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteRedBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2188 1.32846C12.9841 -0.0423093 11.0337 0.510095 9.86198 1.39001C9.38156 1.7508 9.14135 1.93119 9.00002 1.93119C8.85869 1.93119 8.61848 1.7508 8.13806 1.39001C6.96637 0.510095 5.01593 -0.0423093 2.78122 1.32846C-0.151589 3.12745 -0.815212 9.06238 5.94963 14.0695C7.23812 15.0232 7.88236 15.5 9.00002 15.5C10.1177 15.5 10.7619 15.0232 12.0504 14.0695C18.8153 9.06238 18.1516 3.12745 15.2188 1.32846Z",
    fill: "#DF0C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteRedBold);
export default __webpack_public_path__ + "static/media/favourite-red-bold.d58f7630382219a3ef6663c97463546d.svg";
export { ForwardRef as ReactComponent };